// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2731":"301fceed70358b832f95","4285":"52540f53ac6fc166ee0a"}[chunkId] + ".js";
};